// extracted by mini-css-extract-plugin
export default {"thread-mentions":"FeedCardThreadCommon_thread-mentions__Q-DzP"};